export const creditNumber = value => new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Math.ceil(value || 0));
export const usageCreditNumber = value => new Intl.NumberFormat('en-US', { maximumFractionDigits: 6 }).format(value || 0);
const STATUS_LABELS = { draft: 'Setup needed', active: 'Active', past_due: 'Payment past due', canceled: 'Canceled', closed: 'Closed', pending: 'Pending', failed: 'Failed' };
export const statusLabel = (status, paymentHold = false) => paymentHold ? 'Payment under review'
  : STATUS_LABELS[status] || String(status || '').replace(/_/g, ' ').replace(/^./, letter => letter.toUpperCase());
export const seatName = tier => tier === 'premium' ? 'Plus Premium' : 'Plus';
export const dateTime = value => value && Number.isFinite(+new Date(value)) ? new Date(value).toLocaleString() : '—';
export function creditLimit(value) {
  if (!value.trim()) return null;
  if (!/^\d+(\.\d{1,6})?$/.test(value.trim()) || !Number.isSafeInteger(Math.round(Number(value) * 1000000))) {
    throw new Error('Enter a nonnegative credit limit with up to six decimal places, or leave it blank.');
  }
  return Number(value);
}
export const limitText = units => units == null ? '' : String(units / 1000000);
export { requestKey } from './businessRequestKey';
export function invitationToken(hash) {
  const token = new URLSearchParams(String(hash || '').replace(/^#/, '')).get('invite');
  return token && /^[a-f\d]{64}$/.test(token) ? token : null;
}
export function invitationUrl(token, origin) {
  if (!/^[a-f\d]{64}$/.test(token)) throw new Error('The invitation link is unavailable.');
  return `${new URL(origin).origin}/settings?tab=business#invite=${token}`;
}
export function usageDates(from, through) {
  const parse = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) throw new Error('Choose valid usage dates.');
    const date = new Date(`${value}T00:00:00Z`);
    if (!Number.isFinite(+date) || date.toISOString().slice(0, 10) !== value) throw new Error('Choose valid usage dates.');
    return date;
  };
  const start = from ? parse(from) : null, end = through ? parse(through) : null;
  if (start && end && start > end) throw new Error('The end date must follow the start date.');
  return { ...(start ? { from } : {}), ...(end ? { to: new Date(+end + 86400000).toISOString().slice(0, 10) } : {}) };
}
export const usageFeatureLabel = feature => ({ account: 'Gab AI', 'account.chat': 'Chat', 'account.work': 'Work', 'account.api': 'API', 'account.voice': 'Voice', 'account.browser': 'Browser', chat: 'Chat', work: 'Work' })[feature] || feature;
export function usageCsv(rows) {
  const cell = value => {
    let text = String(value ?? '');
    if (/^[\s\uFEFF]*[=+@-]|^[\t\r\n]/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  const columns = ['Date (UTC)', 'Member', 'Member ID', 'Feature', 'Model', 'Status', 'Reserved credits', 'Charged credits', 'Refunded credits', 'Net credits', 'Period'];
  return [columns, ...rows.map(row => [row.createdAt, row.actorName, row.actorId, usageFeatureLabel(row.feature), row.model, row.status,
    row.reservedCredits, row.chargedCredits, row.refundedCredits,
    Math.round((row.chargedCredits - row.refundedCredits) * 1000000) / 1000000, row.periodId])]
    .map(row => row.map(cell).join(',')).join('\r\n');
}
